import { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getUserDefaultSettings } from 'entities/helpers/thankview-helper';
import { useThankViewAuth } from 'apps/signal-video/contexts/thankview-auth-context';

const ThankviewSettingsContext = createContext();

export const ThankviewSettingsProvider = ({ children }) => {
  const [defaultUserSettings, setDefaultUserSettings] = useState({
    button_enabled: false,
    show_in_email: false,
    button_text: '',
    button_url: '',
    logo_enabled: false,
    logo_url: '',
  });
  const { getValidToken } = useThankViewAuth();
  const [loadingDefaultSettings, setLoading] = useState(true);

  useEffect(() => {
    const getAndSetUserSettings = async () => {
      setLoading(true);
      const token = await getValidToken();
      if (token) {
        const { data } = await getUserDefaultSettings(token);
        setDefaultUserSettings({
          updated_at: data.updated_at,
          created_at: data.created_at,
          button_enabled: data?.personal_video_default_button_enabled,
          show_in_email: data?.personal_video_default_show_in_email,
          button_text: data?.personal_video_default_button_text,
          button_url: data?.personal_video_default_button_url,
          logo_enabled: data?.personal_video_default_logo_enabled,
          logo_url: data?.personal_video_default_logo_path,
        });
      }
      setLoading(false);
    };
    getAndSetUserSettings();
  }, [getValidToken]);

  return (
    <ThankviewSettingsContext.Provider value={{ defaultUserSettings, loadingDefaultSettings, setDefaultUserSettings }}>
      {children}
    </ThankviewSettingsContext.Provider>
  );
};

export const useThankviewSettingsContext = () => useContext(ThankviewSettingsContext);

ThankviewSettingsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
